module.exports = __webpack_public_path__ + "img/regular-exercise-yes.dd7f1464.svg";